import { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { Box, Typography, Button, Container, Alert, TextField, Link, CircularProgress, Divider } from '@mui/material';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const { signUp } = useAuthContext();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    if (password.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }

    try {
      setError('');
      setIsLoading(true);
      await signUp(email, password);
      navigate('/dashboard');
    } catch (err: any) {
      console.error('Erreur lors de l\'inscription:', err);
      setError('Une erreur est survenue lors de la création du compte');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" component="h2" fontWeight={700} gutterBottom>
          Créer un compte
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Ou{' '}
          <Link component={RouterLink} to="/login" underline="hover">
            connectez-vous à votre compte
          </Link>
        </Typography>
      </Box>

      <Container maxWidth="xs">
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>
        )}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Adresse email"
            type="email"
            fullWidth
            required
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
          <TextField
            label="Mot de passe"
            type="password"
            fullWidth
            required
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            helperText="Le mot de passe doit contenir au moins 6 caractères."
          />
          <TextField
            label="Confirmer le mot de passe"
            type="password"
            fullWidth
            required
            margin="normal"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            disabled={isLoading}
            sx={{ mt: 2, borderRadius: 2, boxShadow: 2 }}
          >
            {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Créer un compte'}
          </Button>
        </form>

        <Divider sx={{ my: 4 }}>Ou continuez avec</Divider>
        <Button
          variant="outlined"
          color="inherit"
          fullWidth
          startIcon={
            <svg width={20} height={20} viewBox="0 0 24 24" fill="currentColor">
              <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
            </svg>
          }
          sx={{ mb: 2, borderRadius: 2 }}
          onClick={() => {
            // Intégration avec Google à implémenter
          }}
        >
          S'inscrire avec Google
        </Button>
      </Container>
    </div>
  );
};

export default Register;
